import { render, staticRenderFns } from "./ReceiptInfo.vue?vue&type=template&id=46015ceb&scoped=true&"
import script from "./ReceiptInfo.vue?vue&type=script&lang=js&"
export * from "./ReceiptInfo.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptInfo.vue?vue&type=style&index=0&id=46015ceb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46015ceb",
  null
  
)

export default component.exports